import { ButtonHTMLAttributes, ReactNode } from 'react'

type ButtonProps = {
  children: ReactNode
  style:
    | 'primary'
    | 'secondary'
    | 'white'
    | 'danger'
    | 'primary-outline'
    | 'secondary-outline'
  size?: 'xs' | 'sm' | 'md' | 'lg'
  classes?: string
} & ButtonHTMLAttributes<HTMLButtonElement>

export function Button(props: ButtonProps) {
  const { children, style, size, classes, ...rest } = props

  let allClasses =
    'inline-flex items-center border font-medium disabled:opacity-50 disabled:cursor-not-allowed'

  if (style === 'primary') {
    allClasses +=
      ' border-transparent bg-blue-600 text-white hover:bg-blue-700 shadow-sm'
  }

  if (style === 'secondary') {
    allClasses +=
      ' border-transparent bg-blue-100 text-blue-700 hover:bg-blue-200'
  }

  if (style === 'white') {
    allClasses +=
      ' border-gray-300 bg-white text-gray-700 hover:bg-gray-50 shadow-sm'
  }

  if (style === 'danger') {
    allClasses +=
      ' border-transparent bg-red-600 text-white hover:bg-red-700 shadow-sm'
  }

  if (style === 'primary-outline') {
    allClasses +=
      ' border-blue-600 bg-white text-blue-600 hover:bg-blue-50 shadow-sm'
  }

  if (style === 'secondary-outline') {
    allClasses +=
      ' border-blue-100 bg-white text-blue-700 hover:bg-blue-50 shadow-sm'
  }

  if (size === 'xs') {
    allClasses += ' rounded px-2.5 py-1.5 text-sm'
  }

  if (size === 'sm') {
    allClasses += ' rounded-md px-4 py-2 text-sm'
  }

  if (!size || size === 'md') {
    allClasses += ' rounded-md px-4 py-2 text-base'
  }

  if (size === 'lg') {
    allClasses += ' rounded-md px-6 py-3 text-base'
  }

  allClasses += ` ${classes}`

  return (
    <button type="button" className={allClasses} {...rest}>
      {children}
    </button>
  )
}
